// constants
import { FooterActionTypes } from "./constants";

export interface footerActionType {
  type:
    | FooterActionTypes.API_RESPONSE_SUCCESS
    | FooterActionTypes.API_RESPONSE_ERROR
    | FooterActionTypes.UPDATE_FOOTER
    | FooterActionTypes.CREATE_FOOTER
    | FooterActionTypes.GET_FOOTER
    | FooterActionTypes.DELETE_FOOTER;
  payload: {} | string;
}

export interface footerDetails {
  id: string;
  footer_en: string;
  footer_ar: string;
}

// common success
export const footerApiResponseSuccess = (
  actionType: string,
  data: footerDetails | {}
): footerActionType => ({
  type: FooterActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const footerApiResponseError = (
  actionType: string,
  error: string
): footerActionType => ({
  type: FooterActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createfooter = (
  footer_en: string,
  footer_ar: string
): footerActionType => ({
  type: FooterActionTypes.CREATE_FOOTER,
  payload: {
    footer_en,
    footer_ar,
  },
});

export const getfooter = (): footerActionType => ({
  type: FooterActionTypes.GET_FOOTER,
  payload: {},
});

export const deletefooter = (id: string): footerActionType => ({
  type: FooterActionTypes.DELETE_FOOTER,
  payload: { id },
});
export const updatefooter = (
  id: string,
  footer_en: string,
  footer_ar: string
): footerActionType => ({
  type: FooterActionTypes.UPDATE_FOOTER,
  payload: { id, footer_en, footer_ar },
});
